import { render, staticRenderFns } from "./sba-form-details.vue?vue&type=template&id=7c6f65ff&"
import script from "./sba-form-details.vue?vue&type=script&lang=ts&"
export * from "./sba-form-details.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports